"use client";
import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { AutoComplete } from '../AutoComplete/AutoComplete.web.js';
import { IconSearch } from '../icons/ui_general/IconSearch.web.js';
import { IconCross } from '../icons/ui_control/IconCross.web.js';
import { useSmartControlledEventHandler } from '../utils/hooks/useSmartControlledEventHandler.web.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { px2rem } from '../utils/helpers/style.js';

var _excluded = ["value", "onChange", "name", "id", "inputRef", "size", "variant"];
var Search = function Search(_ref) {
  var valueProp = _ref.value,
    onChangeProp = _ref.onChange,
    name = _ref.name,
    id = _ref.id,
    inputRef = _ref.inputRef,
    sizeProp = _ref.size,
    variantProp = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSmartControlledEv = useSmartControlledEventHandler('', valueProp, onChangeProp),
    _useSmartControlledEv2 = _slicedToArray(_useSmartControlledEv, 2),
    value = _useSmartControlledEv2[0],
    onChange = _useSmartControlledEv2[1];
  var handleClear = React.useCallback(function () {
    onChange({
      // TODO: this is not a proper ChangeEvent
      target: {
        name: name,
        value: ''
      },
      currentTarget: {
        name: name,
        value: ''
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    });
  }, [name, onChange]);
  var theme = useTheme();
  var variant = variantProp || theme.variant;
  var size = variant === 'condensed' ? 's' : sizeProp !== null && sizeProp !== undefined ? sizeProp : theme.preferredComponentSize;
  return /*#__PURE__*/React.createElement(AutoComplete, _extends({
    "data-testid": "elemental-Search-".concat(id || name),
    leftIcon: /*#__PURE__*/React.createElement(IconSearch, {
      size: size === 'l' ? 32 : undefined,
      marginTop: size === 'l' ? px2rem(-4) : undefined
    }),
    rightIcon: /*#__PURE__*/React.createElement(IconCross, {
      color: theme.search.web.closeIconColor,
      style: {
        opacity: value.length === 0 ? 0 : 1
      }
    }),
    onRightIconClick: value.length > 0 ? handleClear : undefined,
    labelStyle: "static",
    listOffset: 2,
    onChange: onChange,
    id: id,
    name: name,
    value: value,
    inputRef: inputRef,
    size: size,
    variant: variant
  }, props));
};

export { Search };
